/* lystia-question.js - <lystia-question> (T-E4-09, parity/pdp-forms.md §2; prototype js/pages/pdp.js questionForm()).
   Форма «Задати питання» в акордеоні PDP: канали Telegram/Viber/Телефон/E-mail, валідація, стани form / sending / error / success,
   ?state=q-open|q-sending|q-error|q-success (відкрити пункт id=pdp-question, прокрутити через 350 мс).
   Тексти - з data-* (locales). Транспорт: data-endpoint (A-039, бот @lystia_website_bot); порожній endpoint = імітація 1100 мс без запиту
   (payload - формат бота lystia-bot /api/question, A-051). */
if (!customElements.get('lystia-question')) {
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  const PHONE_RE = /^\+?[\d\s()-]{10,}$/;
  const TG_RE = /^@?[A-Za-z0-9_]{4,32}$/;
  const TESTS = { telegram: TG_RE, viber: PHONE_RE, phone: PHONE_RE, email: EMAIL_RE };
  const SEND_MS = 1100;

  class LystiaQuestion extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.tpl = this.querySelector('template[data-success]');
      this.submitBtn = this.form.querySelector('[data-submit]');
      this.netErr = this.form.querySelector('[data-neterr]');
      this.chips = Array.from(this.form.querySelectorAll('.pq__chan'));
      this.channel = 'telegram';
      this.fields = {
        name: this.mkField(this.form.elements.name),
        contact: this.mkField(this.form.elements.contact),
        text: this.mkField(this.form.elements.question),
      };
      this.form.addEventListener('submit', this.onSubmit);
      this.chips.forEach((c) => c.addEventListener('click', () => this.setChannel(c.dataset.id)));
      Object.values(this.fields).forEach((f) => f.input.addEventListener('input', () => this.setError(f, null)));
      this.applyState(new URLSearchParams(window.location.search).get('state'));
    }

    disconnectedCallback() {
      if (this.form) this.form.removeEventListener('submit', this.onSubmit);
      clearTimeout(this.timer);
      clearTimeout(this.scrollTimer);
    }

    mkField(input) {
      const box = input.closest('.field');
      return { input, box, err: box.querySelector('.field__error') };
    }

    get reduced() {
      return !!(document.lystia && document.lystia.reducedMotion && document.lystia.reducedMotion());
    }

    /* ?state=q-* (seed-стани прототипу) */
    applyState(state) {
      if (!/^q-/.test(state || '')) return;
      const d = this.dataset;
      const item = this.closest('.acc__item');
      if (item) this.setOpen(item, true);
      if (state === 'q-success') this.showSuccess();
      if (state === 'q-sending' || state === 'q-error') {
        this.fields.name.input.value = d.demoName;
        this.fields.contact.input.value = d.demoContact;
        this.fields.text.input.value = d.demoText;
      }
      if (state === 'q-sending') this.setLoading(true);
      if (state === 'q-error') this.showNetError(true);
      this.scrollTimer = setTimeout(() => this.scrollToItem(), 350);
    }

    scrollToItem() {
      const el = this.closest('#pdp-question') || this;
      const y = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top: y, behavior: this.reduced ? 'auto' : 'smooth' });
    }

    /* Пункт акордеона: те саме, що lystia-accordion._set */
    setOpen(item, open) {
      item.classList.toggle('is-open', open);
      const head = item.querySelector('.acc__head');
      const panel = item.querySelector('.acc__panel');
      if (head) head.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (panel) panel.toggleAttribute('inert', !open);
    }

    setChannel(id) {
      const chip = this.chips.find((c) => c.dataset.id === id);
      if (!chip) return;
      this.channel = id;
      this.chips.forEach((c) => {
        const on = c === chip;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      const i = this.fields.contact.input;
      i.type = chip.dataset.type;
      i.placeholder = chip.dataset.ph;
      i.setAttribute('inputmode', chip.dataset.inputmode);
      i.setAttribute('autocomplete', chip.dataset.autocomplete);
      this.setError(this.fields.contact, null);
    }

    setError(f, msg) {
      f.box.classList.toggle('is-error', !!msg);
      f.err.textContent = msg || '';
      if (msg) {
        f.input.setAttribute('aria-invalid', 'true');
        f.input.setAttribute('aria-describedby', f.err.id);
      } else {
        f.input.removeAttribute('aria-invalid');
        f.input.removeAttribute('aria-describedby');
      }
    }

    validate() {
      const d = this.dataset;
      const { name, contact, text } = this.fields;
      const chip = this.chips.find((c) => c.dataset.id === this.channel);
      const n = name.input.value.trim();
      const c = contact.input.value.trim();
      const t = text.input.value.trim();
      this.setError(name, n ? null : d.msgName);
      this.setError(contact, !c ? d.msgContactMissing : TESTS[this.channel].test(c) ? null : chip.dataset.error);
      this.setError(text, t.length >= 10 ? null : t ? d.msgTextShort : d.msgTextMissing);
      return !Object.values(this.fields).some((f) => f.box.classList.contains('is-error'));
    }

    focusFirst() {
      const f = Object.values(this.fields).find((x) => x.box.classList.contains('is-error'));
      if (f) f.input.focus();
    }

    setLoading(on) {
      const b = this.submitBtn;
      const label = b.querySelector('.btn__label');
      b.classList.toggle('is-loading', on);
      b.disabled = on;
      b.setAttribute('aria-busy', on ? 'true' : 'false');
      if (label) label.textContent = on ? this.dataset.labelSending : this.dataset.labelSubmit;
      const sp = b.querySelector('.spinner');
      if (on && !sp) {
        const s = document.createElement('span');
        s.className = 'spinner';
        s.setAttribute('aria-hidden', 'true');
        b.insertBefore(s, b.firstChild);
      }
      if (!on && sp) sp.remove();
      this.dataset.stage = on ? 'sending' : this.dataset.stage === 'sending' ? 'form' : this.dataset.stage;
    }

    showNetError(on) {
      if (!this.netErr) return;
      this.netErr.hidden = !on;
      if (on) {
        /* перезапуск shake при повторній помилці */
        this.netErr.style.animation = 'none';
        void this.netErr.offsetWidth;
        this.netErr.style.animation = '';
      }
      this.dataset.stage = on ? 'error' : 'form';
    }

    onSubmit = (e) => {
      e.preventDefault();
      if (this.submitBtn.classList.contains('is-loading')) return;
      this.showNetError(false);
      if (!this.validate()) {
        this.focusFirst();
        return;
      }
      this.setLoading(true);
      this.send();
    };

    send() {
      const endpoint = this.dataset.endpoint;
      const ok = () => this.showSuccess();
      const fail = () => {
        this.setLoading(false);
        this.showNetError(true);
      };
      if (!endpoint) {
        this.timer = setTimeout(() => (navigator.onLine === false ? fail() : ok()), SEND_MS);
        return;
      }
      /* Формат бота (lystia-bot) POST /api/question: name, contact_method (telegram|viber|phone|email), contact_value, body, product (handle) */
      const body = {
        name: this.fields.name.input.value.trim(),
        contact_method: this.channel,
        contact_value: this.fields.contact.input.value.trim(),
        body: this.fields.text.input.value.trim(),
        product: this.dataset.productHandle || '',
      };
      const map = { name: 'name', contact_value: 'contact', body: 'text' };
      fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
        .then((r) => r.json().catch(() => ({})).then((j) => ({ ok: r.ok && j.ok !== false, status: r.status, j })))
        .then((res) => {
          if (res.ok) { ok(); return; }
          const f = res.status === 400 && res.j.code === 'validation_error' && res.j.error ? this.fields[map[res.j.field]] : null;
          if (f) {
            this.setLoading(false);
            this.setError(f, res.j.error);
            this.focusFirst();
            return;
          }
          throw new Error('http ' + res.status);
        })
        .catch(fail);
    }

    showSuccess() {
      if (!this.tpl) return;
      this.setLoading(false);
      this.showNetError(false);
      const node = this.tpl.content.cloneNode(true);
      const close = node.querySelector('[data-close]');
      if (close) close.addEventListener('click', () => this.closeAfterSuccess());
      this.form.hidden = true;
      this.append(node);
      this.dataset.stage = 'success';
    }

    /* «Закрити»: очистити питання, повернути форму, закрити акордеон */
    closeAfterSuccess() {
      Array.from(this.children).forEach((n) => {
        if (n !== this.form && n !== this.tpl) n.remove();
      });
      this.fields.text.input.value = '';
      this.setError(this.fields.text, null);
      this.form.hidden = false;
      this.dataset.stage = 'form';
      const item = this.closest('.acc__item');
      if (item) {
        this.setOpen(item, false);
        const head = item.querySelector('.acc__head');
        if (head) head.focus({ preventScroll: true });
      }
    }
  }
  customElements.define('lystia-question', LystiaQuestion);
}
